import { axios, API } from './config';

export const packingListsAPI = {
  getAll: async (contractId = null, status = null) => {
    const params = {};
    if (contractId) params.contract_id = contractId;
    if (status) params.status = status;
    const response = await axios.get(`${API}/packing-lists`, { params });
    return response.data;
  },
  
  getById: async (id) => {
    const response = await axios.get(`${API}/packing-lists/${id}`);
    return response.data;
  },
  
  getForContract: async (contractId) => {
    const response = await axios.get(`${API}/packing-lists/contract/${contractId}`);
    return response.data;
  },
  
  create: async (data) => {
    const response = await axios.post(`${API}/packing-lists`, data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await axios.put(`${API}/packing-lists/${id}`, data);
    return response.data;
  },
  
  delete: async (id) => {
    const response = await axios.delete(`${API}/packing-lists/${id}`);
    return response.data;
  },
  
  finalize: async (id) => {
    const response = await axios.patch(`${API}/packing-lists/${id}/finalize`);
    return response.data;
  },
  
  complete: async (id) => {
    const response = await axios.patch(`${API}/packing-lists/${id}/complete`);
    return response.data;
  }
};
